import React from "react";

const ExternalLink = props => (
  <svg height="14" width="14" viewBox="0 0 9 9" {...props}>
    <path
      fill="#707070"
      d="M1 0a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4.5H8V8H1V1h3.5V0H1zm4.5 0v1h1.8L2.64 5.65l.7.7L8 1.71V3.5h1V0H5.5z"
    />
  </svg>
);

export default ExternalLink;
